//const Backofficebff         : string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ShippingPerformanceQuery: any = {
    GetShippingPerformance: Backofficebff + '/v1/cargo/get-cost-performance-bar',
};
